import { toast } from "react-toastify";
import { useGetUtilitiesForAdminQuery, useUpdateUtilityForAdminMutation } from "../../../../../service/utility-service";
import CommonLoadingSpinner from "../../../../../common/components/loading-spinner/CommonLoadingSpinnerForPage";
import EmptyState from "../../../../../common/components/xepp/empty-state/EmptyState";
import { UtilityIcon } from "../../../../../assets/icons";
import { getErrorMessage } from "../../../../../utils/error-handler";
import UtilAdminUtilityForm from "./UtilAdminUtilityForm";


export const UtilAdminUtilityTab = () => {
	const { data, isLoading } = useGetUtilitiesForAdminQuery();
	const [updateUtility, { isLoading: isUpdating }] = useUpdateUtilityForAdminMutation();

	const handleSaveUtility = async (formData: any) => {
		const submitFormData = new FormData();

		submitFormData.append("name", formData.name);

		if (formData.imageFile) {
			submitFormData.append("imageFile", formData.imageFile);
		}

		await updateUtility(submitFormData)
			.unwrap()
			.then(res => {
				toast.success("Utility updated successfully");
			})
			.catch(err => toast.error(getErrorMessage(err?.data)));
	};

	return (
		<div>
			<CommonLoadingSpinner loading={isLoading}>
				{data ? (
					<UtilAdminUtilityForm
						isSaving={isUpdating}
						utility={data}
						onSave={handleSaveUtility}
					/>
				) : (
					<EmptyState icon={<UtilityIcon className="mb-8" />} description="No utilities data available" />
				)}
			</CommonLoadingSpinner>
		</div>
	);
};
